import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import GroupsPage from 'model/GroupsPage'

export class GroupsPagesRepository extends WebRepository<GroupsPage> {
  constructor() {
    super(new Api('groups'))
  }

  async searchGroupsPage(bookmark: string): Promise<GroupsPage> {
    return super.searchPage({
      selector: {},
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchGroupsPageText(bookmark: string, text: string): Promise<GroupsPage> {
    return super.searchPage({
      selector: {
        $or: [
          {
            name: {
              $regex: '(?i)' + text,
            },
          }
        ],
      },
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchMainGroupsPage(bookmark: string): Promise<GroupsPage> {
    return super.searchPage({
      mainGroups: true,
      selector: {},
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchMainGroupsPageText(bookmark: string, text: string): Promise<GroupsPage> {
    return super.searchPage({
      mainGroups: true,
      selector: {
        $or: [
          {
            name: {
              $regex: '(?i)' + text,
            },
          }
        ],
      },
      limit: 10,
      bookmark: bookmark,
    })
  }
}

export default new GroupsPagesRepository()
